<template>
    <a ref="myref" :class="linkedbuttonclass" role="button" tabindex="0" @click="$emit('click')" @keydown.space.prevent="$emit('click')" :disabled="disabled" href="#">{{toplabel}}</a>
   
</template>

<script>
export default {
    name:'linkbutton',
    props:{
        toplabel:{
            type:String, 
        },
        disabled:{
          type:Boolean,
          default:false
        },
        useLightColor:{
            type:Boolean,
            default:false
        }

    },
    computed:{
        linkedbuttonclass(){
            if(this.useLightColor){return "linkedbuttonlight"}
            else{return "linkedbutton"}
        }
    },
    methods:{
      focus(){
        this.$refs.myref.focus()
      }
    }
}
</script>

<style >
.buttontext{
  margin:0px;
}

.linkedbutton{
    text-decoration: underline;
    min-width: 75px;
    
    height:25px;
    padding:0px;
    font-size: inherit;
    margin:0px;
    color:var(--text-color);
}
.linkedbutton:hover{
    color:var(--highlight-button-color);
    cursor:pointer;
}
.linkedbutton:link{
    color:var(--text-color);
}
.linkedbutton:disabled{
  background-color:gray;
}

.linkedbuttonlight{
    text-decoration: underline;
    min-width: 75px;
    
    height:25px;
    padding:0px;
    font-size: inherit;
    margin:0px;
    color:var(--light-text-color);
}
.linkedbuttonlight:hover{
    color:var(--highlight-button-color);
    cursor:pointer;
}
.linkedbuttonlight:link{
    color:var(--light-text-color);
}
.linkedbuttonlight:disabled{
  background-color:gray;
}

</style>